import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    "name": "constructionstatusname",
    standalone: true
})
export class ConstructionStatusNamePipe implements PipeTransform {
    transform (value: number): string {
        switch (value) {
            case 1:
                return "Pending";
            case 2:
                return "Approved";
            case 3:
                return "Rejected";
            default:
                return "";
        }
    }
}
